// import { useEffect, useRef, useState } from 'react';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { Label } from './utils';
// import { fetchAbout } from './data';

// gsap.registerPlugin(ScrollTrigger);

// export default function About({ loaded, isMobile }) {
//   const [about, setAbout] = useState(null);
//   const [ready, setReady] = useState(false);
//   const sectionRef = useRef(null);

//   useEffect(() => {
//     fetchAbout().then(d => { if (d) setAbout(d); }).catch(console.error);
//   }, []);

//   useEffect(() => {
//     if (loaded && about) setReady(true);
//   }, [loaded, about]);

//   useEffect(() => {
//     if (!ready) return;

//     const section = sectionRef.current;
//     const words   = section?.querySelectorAll('.hl-word') ?? [];
//     if (!words.length) return;

//     const ctx = gsap.context(() => {
//       ScrollTrigger.create({
//         trigger: section,
//         start: 'top 50%',
//         end: 'bottom 50%',
//         scrub: 0.4,
//         onUpdate(self) {
//           const litCount = self.progress * words.length;
//           words.forEach((wordEl, i) => {
//             const hl  = wordEl.querySelector('.hl-slab');
//             const txt = wordEl.querySelector('.hl-txt');
//             const wp  = litCount - i;

//             if (wp <= 0) {
//               gsap.set(hl, { scaleX: 0 });
//               txt.style.color = 'var(--cyan)';
//             } else if (wp >= 1) {
//               gsap.set(hl, { scaleX: 1 });
//               txt.style.color = 'var(--black)';
//             } else {
//               gsap.set(hl, { scaleX: wp, transformOrigin: 'left center' });
//               txt.style.color = 'var(--cyan)';
//             }
//           });
//         },
//       });
//     }, section);

//     return () => ctx.revert();
//   }, [ready]);

//   if (!about) return null;

//   const paragraphs  = about.paragraphs  || [];
//   const techStack   = about.techStack   || [];   // ["React", "Express.js", "MySql"]

//   return (
//     <section
//       id="about-me"
//       ref={sectionRef}
//       style={{
//         background: 'var(--black)',
//         overflow: 'hidden',
//         padding: isMobile ? '5rem 5vw 5rem' : '5rem 5vw 2rem',
//         paddingBottom:"5.5rem"
//       }}
//     >
//       {/* Label + Title + Resume Button */}
//       <div style={{ maxWidth: 1200, margin: '0 auto' }}>
//         <Label n="01" text="About Me" />
//         <div style={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           flexWrap: 'wrap',
//           gap: '1rem',
//           marginBottom: '3rem',
//         }}>
//           <h2 style={{
//             fontFamily: 'Syne, sans-serif',
//             fontSize: isMobile ? 'clamp(1.4rem, 5vw, 2rem)' : 'clamp(1.6rem, 3vw, 3rem)',
//             fontWeight: 800,
//             letterSpacing: '-0.04em',
//             lineHeight: 0.9,
//             margin: 0,
//           }}>
//             Who I <span style={{ color: 'var(--acid)' }}>Am</span>
//           </h2>
//           <a
          
//             href={about.resumeUrl || '/naveen_updated.pdf'}
//             download
//             style={{
//               fontFamily: 'Space Mono, monospace',
//               fontSize: '0.62rem',
//               letterSpacing: '0.18em',
//               textTransform: 'uppercase',
//               color: 'var(--black)',
//               background: 'var(--acid)',
//               padding: '0.6rem 1.2rem',
//               textDecoration: 'none',
//               display: 'inline-flex',
//               alignItems: 'center',
//               gap: '0.55rem',
//               transition: 'gap 0.3s cubic-bezier(0.4,0,0.2,1), opacity 0.2s',
//               flexShrink: 0,
//             }}
//             onMouseEnter={e => { e.currentTarget.style.gap = '1rem'; e.currentTarget.style.opacity = '0.85'; }}
//             onMouseLeave={e => { e.currentTarget.style.gap = '0.55rem'; e.currentTarget.style.opacity = '1'; }}
//           >
//             Download Resume
//           </a>
//         </div>
//       </div>

//       {/* Highlighted scroll-reveal text — full bleed */}
//       <div
//         style={{
//           fontFamily: 'Syne',
//           fontWeight: 800,
//           fontSize: isMobile
//             ? 'clamp(1.4rem, 5vw, 2rem)'
//             : 'clamp(1.5rem, 2.4vw, 2.4rem)',
//           lineHeight: 1.25,
//           letterSpacing: '-0.03em',
//         }}
//       >
//         {paragraphs.map((line, li) => (
//           <span key={li} style={{ display: 'inline' }}>
//             {line.split(' ').map((word, wi) => (
//               <span
//                 key={wi}
//                 className="hl-word"
//                 style={{
//                   display: 'inline-block',
//                   position: 'relative',
//                   marginRight: '0.22em',
//                   whiteSpace: 'nowrap',
//                 }}
//               >
//                 <span
//                   className="hl-slab"
//                   style={{
//                     position: 'absolute',
//                     inset: '2px -4px 1px -4px',
//                     background: 'var(--acid)',
//                     borderRadius: 2,
//                     transform: 'scaleX(0)',
//                     transformOrigin: 'left center',
//                     zIndex: 0,
//                     pointerEvents: 'none',
//                   }}
//                 />
//                 <span
//                   className="hl-txt"
//                   style={{
//                     position: 'relative',
//                     zIndex: 1,
//                     color: 'var(--cyan)',
//                     transition: 'color 0.08s',
//                   }}
//                 >
//                   {word}
//                 </span>
//               </span>
//             ))}
//             {li < paragraphs.length - 1 && <br />}
//           </span>
//         ))}
//       </div>

//       {/* ── Tech Stack ── */}
//       {techStack.length > 0 && (
//         <div

//   style={{
//     maxWidth: 1200,
//     margin: '1.5rem auto 0',
//   }}
// >        
//           {/* Row: label left, pills right */}
//           <div
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               flexWrap: 'wrap',
//               gap: isMobile ? '1rem' : '1.5rem',
//             }}
//           >
//             <span
//               style={{
//                 fontFamily: 'Space Mono, monospace',
//                 fontSize: '0.6rem',
//                 letterSpacing: '0.2em',
//                 textTransform: 'uppercase',
//                 color: 'var(--muted)',
//                 flexShrink: 0,
//               }}
//             >
//               Tech Stack
//             </span>

//             <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
//               {techStack.map((tech, i) => (
//                 <span
//                   key={i}
//                   style={{
//                     fontFamily: 'Space Mono, monospace',
//                     fontSize: '0.65rem',
//                     letterSpacing: '0.12em',
//                     textTransform: 'uppercase',
//                     color: 'var(--acid)',
//                     border: '1px solid var(--acid)',
//                     padding: '0.35rem 0.85rem',
//                     borderRadius: 2,
//                     whiteSpace: 'nowrap',
//                     opacity: 0.85,
//                   }}
//                 >
//                   {tech}
//                 </span>
//               ))}
//             </div>
//           </div>
//         </div>
//       )}
//     </section>
//   );
// }
import { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Label } from './utils';
import { fetchAbout } from './data';

gsap.registerPlugin(ScrollTrigger);

export default function About({ loaded, isMobile }) {
  const [about, setAbout] = useState(null);
  const [ready, setReady] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    fetchAbout().then(d => { if (d) setAbout(d); }).catch(console.error);
  }, []);

  useEffect(() => {
    if (loaded && about) setReady(true);
  }, [loaded, about]);

  useEffect(() => {
    if (!ready) return;

    const section = sectionRef.current;
    const words   = section?.querySelectorAll('.hl-word') ?? [];
    if (!words.length) return;

    const ctx = gsap.context(() => {
      ScrollTrigger.create({
        trigger: section,
        start: 'top 50%',
        end: 'bottom 50%',
        scrub: 0.4,
        onUpdate(self) {
          const litCount = self.progress * words.length;
          words.forEach((wordEl, i) => {
            const hl  = wordEl.querySelector('.hl-slab');
            const txt = wordEl.querySelector('.hl-txt');
            const wp  = litCount - i;

            if (wp <= 0) {
              gsap.set(hl, { scaleX: 0 });
              txt.style.color = 'var(--cyan)';
            } else if (wp >= 1) {
              gsap.set(hl, { scaleX: 1 });
              txt.style.color = 'var(--black)';
            } else {
              gsap.set(hl, { scaleX: wp, transformOrigin: 'left center' });
              txt.style.color = 'var(--cyan)';
            }
          });
        },
      });
    }, section);

    return () => ctx.revert();
  }, [ready]);

  if (!about) return null;

  const paragraphs = about.paragraphs || [];

  return (
    <section
      id="about-me"
      ref={sectionRef}
      style={{
        background: 'var(--black)',
        overflow: 'hidden',
        padding: isMobile ? '5rem 5vw' : '5rem 5vw',
        paddingBottom:"0px"
      }}
    >
      {/* Label + Title + Resume Button */}
      <div style={{ margin: '0 auto' }}>
        <Label n="01" text="About Me" />
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '1rem',
          marginBottom: '3rem',
        }}>
          <h2 style={{
            fontFamily: 'Syne, sans-serif',
            fontSize: isMobile ? 'clamp(1.4rem, 5vw, 2rem)' : 'clamp(1.6rem, 3vw, 3rem)',
            fontWeight: 800,
            letterSpacing: '-0.04em',
            lineHeight: 0.9,
            margin: 0,
          }}>
            Who I <span style={{ color: 'var(--acid)' }}>Am</span>
          </h2>
          <a
            href={about.resumeUrl || '/naveen_updated.pdf'}
            download
            style={{
              fontFamily: 'Space Mono, monospace',
              fontSize: '0.62rem',
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
              color: 'var(--black)',
              background: 'var(--acid)',
              padding: '0.6rem 1.2rem',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.55rem',
              transition: 'gap 0.3s cubic-bezier(0.4,0,0.2,1), opacity 0.2s',
              flexShrink: 0,
            }}
            onMouseEnter={e => { e.currentTarget.style.gap = '1rem'; e.currentTarget.style.opacity = '0.85'; }}
            onMouseLeave={e => { e.currentTarget.style.gap = '0.55rem'; e.currentTarget.style.opacity = '1'; }}
          >
            Download Resume
          </a>
        </div>
      </div>

      {/* Highlighted scroll-reveal text — full bleed */}
      <div
        style={{
          fontFamily: 'Syne',
          fontWeight: 800,
          fontSize: isMobile
            ? 'clamp(1.4rem, 5vw, 2rem)'
            : 'clamp(1.5rem, 2.4vw, 2.4rem)',
          lineHeight: 1.25,
          letterSpacing: '-0.03em',
        }}
      >
        {paragraphs.map((line, li) => (
          <span key={li} style={{ display: 'inline' }}>
            {line.split(' ').map((word, wi) => (
              <span
                key={wi}
                className="hl-word"
                style={{
                  display: 'inline-block',
                  position: 'relative',
                  marginRight: '0.22em',
                  whiteSpace: 'nowrap',
                }}
              >
                <span
                  className="hl-slab"
                  style={{
                    position: 'absolute',
                    inset: '2px -4px 1px -4px',
                    background: 'var(--acid)',
                    borderRadius: 2,
                    transform: 'scaleX(0)',
                    transformOrigin: 'left center',
                    zIndex: 0,
                    pointerEvents: 'none',
                  }}
                />
                <span
                  className="hl-txt"
                  style={{
                    position: 'relative',
                    zIndex: 1,
                    color: 'var(--cyan)',
                    transition: 'color 0.08s',
                  }}
                >
                  {word}
                </span>
              </span>
            ))}
            {li < paragraphs.length - 1 && <br />}
          </span>
        ))}
      </div>
    </section>
  );
}